import gql from 'graphql-tag'
import { QuestionFragment, AnswersFragment } from './'

export default gql`
  query guarantor($entityId: Int!) {
    guarantor(rid: $entityId) {
      rid
      name
      principal
      citizenship
      type
      ${AnswersFragment}
      questions {
        ${QuestionFragment}
      }
      entityQuestions {
        ${QuestionFragment}
      }
      affiliates {
        rid
        name
      }
    }
  }
`
